import { isApiError, request } from '@counsel-project/client-utils'

const url = import.meta.env.DEV ? 'http://localhost:3001/api' : '/api'

const getStringified = (err: unknown) => {
  if (isApiError(err)) {
    return `${err.status} ${err.msg}\n${err.stack}`
  }
  if (err instanceof Error) {
    return `${err.message}\n${err.stack}`
  }
  if (typeof err === 'string') {
    return err
  }
  if (typeof err === 'object' && !!err) {
    return err.toString()
  }
  return JSON.stringify(err)
}

const info = (message: unknown, ...args: unknown[]) => {
  const fullMessage = `${getStringified(message)} ${args
    .map((arg) => getStringified(arg))
    .join(' ')}`

  request({
    method: 'post',
    url: url + '/log',
    body: {
      msg: fullMessage,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }).catch((err) => {
    console.error(err)
  })

  console.log(fullMessage)
}

const error = (message: unknown, ...args: unknown[]) => {
  const fullMessage = `${getStringified(message)} ${args
    .map((arg) => getStringified(arg))
    .join(' ')}`

  request({
    method: 'post',
    url: url + '/error',
    body: {
      msg: fullMessage,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }).catch((err) => {
    console.error(err)
  })

  console.error(fullMessage)
}

const warn = (message: unknown, ...args: unknown[]) => {
  const fullMessage = `${getStringified(message)} ${args
    .map((arg) => getStringified(arg))
    .join(' ')}`

  request({
    method: 'post',
    url: url + '/warn',
    body: {
      msg: fullMessage,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }).catch((err) => {
    console.error(err)
  })

  console.warn(fullMessage)
}

const log = {
  error,
  info,
  warn,
}

export default log
